import React from 'react';

import PlayOutline from 'crehana-icons/PlayOutline';
import LargeBadge from 'crehana-icons/LargeBadge';
import SeparatedBars from 'crehana-icons/SeparatedBars';

import RequirementsSection from './RequirementsSection';
import AboutSection from './AboutSection';

import { secondaryDark, baseLighter } from 'crehana-ui/styles/colors';

const renderIcon = (index, alternativeColor = false) => {
  switch (index) {
    case 0:
      return (
        <SeparatedBars
          className="mr-8"
          size={12}
          color={alternativeColor ? secondaryDark : baseLighter}
        />
      );
    case 1:
      return (
        <LargeBadge
          className="ml-4 mr-12"
          size={17}
          color={alternativeColor ? secondaryDark : baseLighter}
        />
      );
    case 2:
      return (
        <PlayOutline
          className="mr-8"
          size={15}
          color={alternativeColor ? secondaryDark : baseLighter}
        />
      );
    default:
      return null;
  }
};

const LegacyUI = ({ course }) => {
  return (
    <div className="py-24 lg:py-40">
      {/* Features */}
      <div className="pb-48 border-b border-solid border-gray-light md:border md:p-32 mb-48">
        {course.basicInfoV2 && (
          <ul className="relative">
            {course?.basicInfoV2?.map((el, index) => {
              if (el.text) {
                return (
                  <li
                    key={`item-${index}`}
                    className={`${index !== course.basicInfoV2.length - 1 &&
                      'mb-16 sm:mb-24'}`}
                  >
                    <div className="flex items-center">
                      <div className="lg:hidden">{renderIcon(index)}</div>
                      <div className="hidden  lg:block">
                        {renderIcon(index, true)}
                      </div>
                      <h2 className="lg:text-secondary-dark font-subtitle2 text-base-lighter">
                        {el.title}
                      </h2>
                    </div>
                    <p className="font-body3">{el.text}</p>
                  </li>
                );
              }
            })}
          </ul>
        )}
      </div>
      {course?.requirements?.length > 0 && (
        <RequirementsSection course={course} />
      )}
      <AboutSection course={course} />
    </div>
  );
};

export default LegacyUI;
